import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentsModule} from '../../../components/components.module';
import {TableModule} from 'primeng/table';
import {TagModule} from 'primeng/tag';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {RoleEditComponent} from './role-edit/role-edit.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {InputTextModule} from 'primeng/inputtext';
import {MultiSelectModule} from 'primeng/multiselect';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';
import {ToastModule} from 'primeng/toast';
import {DividerModule} from 'primeng/divider';
import {InputMaskModule} from 'primeng/inputmask';
import {ButtonModule} from 'primeng/button';
import {SelectButtonModule} from 'primeng/selectbutton';
import {InputGroupModule} from 'primeng/inputgroup';
import {InputGroupAddonModule} from 'primeng/inputgroupaddon';
import {RoleComponent} from './role.component';
import {TranslateModule} from "@ngx-translate/core";
import { TooltipModule } from 'primeng/tooltip';
import { PipesModule } from '../../../pipes/pipes.module';


@NgModule({
    declarations: [RoleComponent, RoleEditComponent],
    imports: [
        CommonModule,
        ComponentsModule,
        TableModule,
        TagModule,
        DialogModule,
        ConfirmDialogModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        InputTextModule,
        MultiSelectModule,
        DropdownModule,
        CheckboxModule,
        ToastModule,
        DividerModule,
        InputMaskModule,
        ButtonModule,
        SelectButtonModule,
        InputGroupModule,
        InputGroupAddonModule,
        TranslateModule,
        TooltipModule,
        PipesModule 
    ],
    exports: [RoleComponent, RoleEditComponent]
})
export class RoleModule {
}
